
import { Button } from '05-ui-kit';
interface Props {
  count?: number;
  loading?: boolean;
  type: 'preorder' | 'default';
}
const __sfc_main = {};
__sfc_main.props = {
  count: {
    key: "count",
    required: false,
    type: Number
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'default'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {
    emit
  };
};
__sfc_main.components = Object.assign({
  Button
}, __sfc_main.components);
export default __sfc_main;
